import React, { useEffect } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import pic1 from "../../../assets/images/handling medical bill home page.jpg";
import { useNavigate } from "react-router-dom";
const MedicalBilling = () => {
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="text-gray-800" style={{ marginTop: "80px" }}>
      <motion.header
        className="bg-blue-900 text-white py-16 text-center shadow-lg rounded-lg"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="bg-gradient-to-r from-blue-50 to-indigo-100 py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                <span className="text-white">
                  {" "}
                  🏥 We Handle the Billing, You Focus{" "}
                </span>
                <span className="text-blue-600"> on Healing!</span>
              </h1>
              <p className="mt-4" style={{ fontWeight: "bold" }}>
                Professional Medical Billing Services by Twenty Four Seven
                Consultancy
              </p>
              <p className="text-white mt-4 mb-8">
                At Twenty Four Seven Consultancy, we take the stress out of your
                revenue cycle. Our expert billing solutions save you time,
                reduce administrative burden, and maximize your revenue—so you
                can focus on what truly matters: your patients.
              </p>
              <button
                onClick={() => navigate("/bookmeeting")}
                style={{ color: "black" }}
                className="bg-white text-blue-700 px-6 py-3 font-bold rounded-full hover:bg-blue-100 transition"
              >
                Meet Us
              </button>
            </div>
          </div>
        </div>
      </motion.header>

      {/* Introduction Section */}
      <motion.section
        className="py-16 text-left bg-white"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        data-aos="fade-up"
      >
        <section
          id="medical-billing"
          className="py-20 bg-gray-50 px-6 md:px-20"
        >
          <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            {/* Left Content */}
            <div>
              <h2 className="text-3xl font-bold text-blue-900 mb-4">
                💸 Maximize Revenue, Minimize Stress
              </h2>
              <h5 className="font-bold text-gray-700 mb-4">
                Comprehensive Medical Billing Solutions That Deliver Results
              </h5>
              <ul className="text-sm text-gray-700 space-y-2 mb-4 pl-5">
                <li>✅ Claims submission, payment posting, and follow-up</li>
                <li>🔁 Denial management and revenue cycle optimization</li>
                <li>📈 Detailed reporting and performance analytics</li>
                <li>
                  🎯 Customized solutions tailored to your specialty and
                  workflow
                </li>
              </ul>
              <p className="text-sm text-gray-700 max-w-xl">
                With in-depth knowledge of current billing codes and regulatory
                updates, our team ensures accurate, compliant claims—improving
                cash flow and reducing delays.
              </p>
            </div>

            {/* Right Image */}
            <div className="flex justify-center">
              <img
                src={pic1}
                alt="Medical Billing Illustration"
                className="w-full max-w-md h-auto object-contain rounded-xl"
              />
            </div>
          </div>
        </section>
      </motion.section>

      <motion.div
        className="p-6 bg-white rounded-lg transition duration-300"
        data-aos="fade-up"
      >
        <section
          id="code-right"
          className="py-24 bg-gradient-to-r mt-4 from-blue-50 to-white px-8 md:px-24"
        >
          <div className="container mx-auto text-center bg-white shadow-xl rounded-2xl p-10">
            <h2 className="text-4xl font-extrabold text-blue-800 mb-4">
              🧾 Code Right, Get Paid Right
            </h2>
            <p className="text-base text-gray-700 mb-6">
              Expert Coding & Documentation Review Services
            </p>
            <div className="grid gap-4 md:grid-cols-3 text-sm text-gray-700 text-left">
              <div className="bg-gray-100 p-4 rounded-xl">
                ✅ Thorough chart audits and coding validations
              </div>
              <div className="bg-gray-100 p-4 rounded-xl">
                💡 Support for accurate ICD-10, CPT, and HCPCS coding
              </div>
              <div className="bg-gray-100 p-4 rounded-xl">
                📉 Denial prevention and appeals management
              </div>
            </div>
            <p className="text-sm text-gray-700 mt-4">
              Let us help you submit clean claims the first time, every time.
            </p>
          </div>
        </section>
      </motion.div>

      <motion.div
        className="p-6 bg-white rounded-lg transition duration-300"
        data-aos="fade-up"
      >
        <section
          id="credentialing"
          className="py-24 bg-white mt-4 px-8 md:px-24"
        >
          <div className="container mx-auto text-center bg-gray-50 shadow-xl rounded-2xl p-10">
            <h2 className="text-4xl font-extrabold text-blue-800 mb-4">
              🆔 Credentialing with Confidence
            </h2>
            <p className="text-base text-gray-700 mb-6">
              Let Us Handle the Paperwork While You Grow
            </p>
            <div className="grid gap-4 md:grid-cols-3 text-sm text-gray-700 text-left">
              <div className="bg-white p-4 rounded-xl border">
                📋 Provider enrollment and payer registration
              </div>
              <div className="bg-white p-4 rounded-xl border">
                🔄 Ongoing credentialing maintenance
              </div>
              <div className="bg-white p-4 rounded-xl border">
                🛡️ Compliance with insurer and regulatory standards
              </div>
            </div>
            <p className="text-sm text-gray-700 mt-4">
              Focus on building your practice—we’ll make sure you're properly
              credentialed and ready to bill.
            </p>
          </div>
        </section>
      </motion.div>

      <motion.div
        className="p-6 bg-white rounded-lg transition duration-300"
        data-aos="fade-up"
      >
        <section
          id="compliance-support"
          className="py-24 bg-gradient-to-r from-white mt-4 to-blue-50 px-8 md:px-24"
        >
          <div className="container mx-auto text-center bg-white shadow-xl rounded-2xl p-10">
            <h2 className="text-4xl font-extrabold text-blue-800 mb-4">
              ⚖️ Stay Compliant, Avoid Penalties
            </h2>
            <p className="text-base text-gray-700 mb-6">
              Trusted Compliance Support
            </p>
            <div className="grid gap-4 md:grid-cols-3 text-sm text-gray-700 text-left">
              <div className="bg-gray-100 p-4 rounded-xl">
                📚 Up-to-date with federal and payer-specific rules
              </div>
              <div className="bg-gray-100 p-4 rounded-xl">
                📑 Regular audits and billing reviews
              </div>
              <div className="bg-gray-100 p-4 rounded-xl">
                🛡️ Expert advice on HIPAA, OIG, and CMS guidelines
              </div>
            </div>
            <p className="text-sm text-gray-700 mt-4">
              Our goal: keeping your practice compliant, protected, and
              penalty-free.
            </p>
          </div>
        </section>
      </motion.div>
      <motion.div
        className="p-6 bg-white rounded-lg transition duration-300"
        data-aos="fade-up"
      >
        <section
          id="why-choose-us"
          className="py-24 bg-white mt-4 px-8 md:px-24"
        >
          <div className="container mx-auto text-center bg-blue-50 shadow-xl rounded-2xl p-10">
            <h2 className="text-4xl font-extrabold text-blue-800 mb-4">
              🤝 Why Choose Twenty Four Seven Consultancy?
            </h2>
            <div className="grid gap-4 md:grid-cols-2 text-sm text-gray-700 text-left">
              <div className="bg-white p-4 rounded-xl border">
                ✔️ Experienced Billing Professionals – Skilled in all
                specialties and EHR platforms
              </div>
              <div className="bg-white p-4 rounded-xl border">
                ✔️ Customized Solutions – Services tailored to your practice’s
                size, specialty, and needs
              </div>
              <div className="bg-white p-4 rounded-xl border">
                ✔️ Advanced Technology – Cloud-based tools for accuracy,
                security, and real-time reporting
              </div>
              <div className="bg-white p-4 rounded-xl border">
                ✔️ Transparent Pricing – No hidden costs, just honest billing
              </div>
              <div className="bg-white p-4 rounded-xl border">
                ✔️ Dedicated Support – Fast, friendly, and responsive
                service—24/7
              </div>
            </div>
          </div>
        </section>
      </motion.div>
      {/* Ready to Start Section */}
      <motion.section
        className="py-16 text-center bg-gray-100"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        data-aos="fade-up"
      >
        <h2 className="text-3xl font-bold text-blue-900">
          🚀 Ready to Experience Hassle-Free Billing?
        </h2>
        <h5 className="mt-4 text-blue-900">
          🔗 Let’s Start Together — Partner with Twenty Four Seven Consultancy
          and discover a better way to manage your revenue cycle.
        </h5>
        <h5 className="mt-4 text-blue-900">
          📩 Contact us today for a consultation or quote.
        </h5>
      </motion.section>
    </div>
  );
};

export default MedicalBilling;
